<template>
  <v-alert
    :style="{
      ...(maxWidth ? { 'max-width': `${maxWidth}px` } : {}),
    }"
    border="top"
    colored-border
    type="warning"
    elevation="2"
  >
    <div>
      <Header4>{{ title }}</Header4>
      <TextBody>
        {{ message }}
      </TextBody>
    </div>
  </v-alert>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import Header4 from "app/ui-primitives/header/Header4.vue"
import TextBody from "components/UI/TextBody.vue"

export default defineComponent({
  name: "WarningAlert",
  components: { TextBody, Header4 },
  props: {
    title: {
      type: String,
      default: "Achtung",
    },
    message: {
      type: String,
      required: true,
    },
    maxWidth: {
      type: Number,
      default: null,
    },
  },
})
</script>
